export default __webpack_public_path__ + "static/media/covid19.4fa265c8.svg";